window.moment = require("moment");

require("moment-jdateformatparser");
